import React, { useState, useEffect } from "react";

const useDataLocale = (data, _locale, langKey = "lang") => {
  // local state
  const [dataLocale, setDataLocale] = useState([]);

  useEffect(() => {
    if (_locale && Array.isArray(data)) {
      if (_locale.indexOf("zh") >= 0) {
        const tmpDataLocale = data.filter((o) => o?.[langKey] === "zh");
        setDataLocale(tmpDataLocale);
      } else {
        const tmpDataLocale = data.filter((o) => o?.[langKey] === "en");
        setDataLocale(tmpDataLocale);
      }
    }
  }, [data, _locale]);

  return { dataLocale };
};

export default useDataLocale;
